import * as events from "events";

import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Domain as WebsideDomain } from "../../../lib/Domain/Webside";

@Injectable()
export class SmartPanelService extends events.EventEmitter {
  constructor(private http: Http) { super(); }
  public async List(): Promise<WebsideDomain.IProduct[]> {
    const result = await this.http.get("/api/smartpanel/list")
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IProduct[];
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async Status(smartPanelUUID: string): Promise<WebsideDomain.ISmartPanelStatusResult> {
    const result = await this.http.post("/api/smartpanel/status", { uuid: smartPanelUUID })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.ISmartPanelStatusResult;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async CBstatus(smartPanelUUID: string, cbUUID: string): Promise<WebsideDomain.ISmartPanelStatusCBResult | undefined> {
    const result = await this.http.post("/api/smartpanel/cbstatus", { Paneluuid: smartPanelUUID, CBuuid: cbUUID })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.ISmartPanelStatusCBResult;
    } else {
      return undefined;
    }
  }
  public async SmartCBRelayControl(smartPanelUUID: string, cbUUID: string, relayStatus: boolean): Promise<void> {
    const result = await this.http.post("/api/smartpanel/cbrelay", <WebsideDomain.ISmartCBRelayControlRequest>{
      server_uuid: smartPanelUUID,
      uuid: cbUUID,
      Status: relayStatus,
    })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return;
    } else {
      throw new Error(`${result.message}`);
    }
  }

  public async SmartPlugRelayControl(smartPanelUUID: string, MAC: string, relayStatus: boolean): Promise<void> {
    const result = await this.http.post("/api/smartpanel/plugrelay", <WebsideDomain.ISmartPlugRelayControlRequest>{
      server_uuid: smartPanelUUID,
      MAC: MAC,
      Status: relayStatus,
    })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return;
    } else {
      throw new Error(`${result.message}`);
    }
  }

  public async SmartCBLoadProfiles(smartCBUUID: string, start: Date, end: Date): Promise<WebsideDomain.ISmartCBLoadProfileResult[]> {
    const result = await this.http.post("/api/smartpanel/loadprofile", <WebsideDomain.ISmartPanelRequest>
      { uuid: smartCBUUID, start: start, end: end })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.ISmartCBLoadProfileResult[];
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async SmartCBEvents(smartCBUUID: string, start: Date, end: Date): Promise<WebsideDomain.ISmartCBEventResult[]> {
    const result = await this.http.post("/api/smartpanel/event", <WebsideDomain.ISmartPanelRequest>
      { uuid: smartCBUUID, start: start, end: end })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.ISmartCBEventResult[];
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async SmartCBUsages(smartCBUUID: string): Promise<WebsideDomain.ISmartPanelUsages> {
    const result = await this.http.post("/api/smartpanel/cbusage", { uuid: smartCBUUID })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.ISmartPanelUsages;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async SmartCBProtectionSet(smartPanelUUID: string, smartCBUUID: string,
    protection: WebsideDomain.ISmartCBConfigProtection): Promise<void> {
    const result = await this.http.post("/api/smartpanel/cbprotection", <WebsideDomain.ISmartCBConfigProtectionRequest>{
      server_uuid: smartPanelUUID,
      uuid: smartCBUUID,
      enable: protection.enable,
      current_max: protection.current_max,
      voltage_max: protection.voltage_max,
      voltage_mIn: protection.voltage_mIn,
      peak_cycle: protection.peak_cycle,
      sag_cycle: protection.sag_cycle,
    })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return;
    } else {
      throw new Error(`${result.message}`);
    }
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/smart-panel.service.ts